import { render, staticRenderFns } from "./log-history-obj-detail-modal.vue?vue&type=template&id=2bf6cbfb&scoped=true&"
import script from "./log-history-obj-detail-modal.vue?vue&type=script&lang=js&"
export * from "./log-history-obj-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./log-history-obj-detail-modal.vue?vue&type=style&index=0&id=2bf6cbfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf6cbfb",
  null
  
)

export default component.exports